var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 23.4167C18.7291 23.4167 23.4166 18.7292 23.4166 13C23.4166 7.27087 18.7291 2.58337 12.9999 2.58337C7.27075 2.58337 2.58325 7.27087 2.58325 13C2.58325 18.7292 7.27075 23.4167 12.9999 23.4167Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.052 15.948L15.9478 10.0521",
    stroke: "#2B2B2B",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9478 15.948L10.052 10.0521",
    stroke: "#2B2B2B",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.5fef1f6b3d0a9d497b7bc9a4bcec7992.svg";
export { ForwardRef as ReactComponent };